import React from 'react'

export const INPUT_BASE: React.CSSProperties = {
  width: '100%', padding: '0.65rem 0.875rem', background: 'var(--bg-base)', border: '1px solid var(--border)',
  borderRadius: '8px', color: 'var(--text-primary)', fontSize: '0.875rem', outline: 'none',
  boxSizing: 'border-box', transition: 'border-color 0.15s', fontFamily: 'inherit',
}
